import Vue from "vue";
import App from "./App.vue";
import "./mintui";
import "./axiosIntercept";
import "mint-ui/lib/style.css";
import "./my-mint.scss";
import "./base.css";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
import VideoPlayer from "vue-video-player";
import { MessageBox } from "mint-ui";
import store from "./store";
import router from "./router";
import axios from "axios";
import qs from "qs";
import Router from "vue-router";
/**
 * 注册视频插件
 */
Vue.use(VideoPlayer);
Vue.config.productionTip = false;
/**
 * 注册vue实例
 */

//自定义指令  登录拦截
Vue.directive("login", {
    // 当被绑定的元素插入到 DOM 中时……
    inserted: function(el, binding) {
        axios
            .post(
                "/wap/userHandle/getUserInfo",
            )
            .then(data => {
                var data = data.data.data;
                if (data === 'notLogin') {
                    el.onclick = function() {
                        MessageBox.confirm("立即登录")
                            .then(() => {
                                router.push({
                                    path: "/login",
                                    query: { redirect: location.hostname }
                                });
                            })["catch"](() => {
                                return false;
                            });
                    };
                } else {
                    return false;
                }
            })["catch"](error => {
                console.log(error);
            });


    }
});

//使页面中可以直接使用 remote-script标签 例如：<remote-script src="http://pv.sohu.com/cityjson?ie=utf-8"></remote-script>
Vue.component("remote-script", {
    render: function(createElement) {
        let self = this;
        return createElement("script", {
            attrs: {
                type: "text/javascript",
                src: this.src
            },
            on: {
                load: function(event) {
                    self.$emit("load", event);
                },
                error: function(event) {
                    self.$emit("error", event);
                },
                readystatechange: function(event) {
                    if (this.readyState == "complete") {
                        self.$emit("load", event);
                    }
                }
            }
        });
    },

    props: {
        src: {
            type: String,
            required: true
        }
    }
});

/**
 * 公用的支付接口
 */
//微信外支付
Vue.prototype.$WxH5AppPay = function(url, param, callback, fail) {
    axios.post(url, qs.stringify(param)).then((res) => {
        callback && (typeof(callback) === "function") && callback(res.data);
    }).catch((err) => {
        fail && (typeof(fail) === "function") && fail(err);
    });
};
//微信内支付
Vue.prototype.$WxJsapiPay = function(url, param, callback, fail) {
    axios.post(url, qs.stringify(param)).then((data) => {
        let res = data.data;
        if (res.code == 200) {
            var WxPackage = {
                appId: res.data.appId, //公众号名称，由商户传入
                timeStamp: res.data.timeStamp, //时间戳，自1970年以来的秒数
                nonceStr: res.data.nonceStr, //随机串
                package: res.data.package,
                signType: res.data.signType, //微信签名方式：
                paySign: res.data.paySign //微信签名
            };

            function OnBridgeReady() {
                WeixinJSBridge.invoke("getBrandWCPayRequest", WxPackage, function(result) {
                    if (result.err_msg == "get_brand_wcpay_request:ok") {
                        callback && (typeof(callback) === "function") && callback(param); //支付成功
                    } else {
                        fail && (typeof(fail) === "function") && fail(result); //支付失败
                    }
                });
            }

            if (typeof WeixinJSBridge == "undefined") {
                //监听事件
                if (document.addEventListener) {
                    document.addEventListener("WeixinJSBridgeReady", OnBridgeReady, false);
                } else if (document.attachEvent) {
                    document.attachEvent("WeixinJSBridgeReady", OnBridgeReady);
                    document.attachEvent("onWeixinJSBridgeReady", OnBridgeReady);
                } else {
                    console.log('事件监听失败');
                }
            } else {
                OnBridgeReady();
            }
        } else {
            fail && (typeof(fail) === "function") && fail(data);
        }
    }).catch((err) => {
        fail && (typeof(fail) === "function") && fail(err);
    });
};
//jsapi 微信内支付
// Vue.prototype.$WxJsapiPay = function(url, param, callback, fail) {
//     axios.post(url, qs.stringify(param))
//         .then((data) => {
//             //调起微信内支付
//             function onBridgeReady(vue) {
//                 var _this = vue;
//                 WeixinJSBridge.invoke(
//                     'getBrandWCPayRequest', {
//                         "appId": data.data.data.appId, //公众号名称，由商户传入
//                         "timeStamp": data.data.data.timeStamp, //时间戳，自1970年以来的秒数
//                         "nonceStr": data.data.data.nonceStr, //随机串
//                         "package": data.data.data.package,
//                         "signType": data.data.data.signType, //微信签名方式：
//                         "paySign": data.data.data.paySign //微信签名
//                     },
//                     function(res) {
//                         console.log(res);
//                         if (res.err_msg == "get_brand_wcpay_request:ok") {
//
//                             // 使用以上方式判断前端返回,微信团队郑重提示：
//                             //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
//                             // _this.$router.push({
//                             //     path: '/orderDel',
//                             //     query: {id: data.data.orderId, packetMony: _this.decPrice}
//                             // });
//                             callback && (typeof(callback) === "function") && callback();
//                         } else {
//                             fail && (typeof(fail) === "function") && fail();
//                         }
//                     });
//             }
//             if (typeof WeixinJSBridge == "undefined") {
//                 if (document.addEventListener) {
//                     document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
//                 } else if (document.attachEvent) {
//                     document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
//                     document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
//                 }
//             } else {
//                 onBridgeReady(this);
//             }
//         })
//         .catch((error) => {
//             console.log(error);
//         })
// }

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");

/**
 * 添加页面title
 */

//登录拦截  去登录
// router.beforeEach((to, from, next) => {
//   if (to.meta.login && !(localStorage.getItem("logined") === "false")) {
//     MessageBox.confirm("立即111登录")
//       .then(() => {
//         router.push({
//           path: "/login",
//           query: { redirect: location.hostname }
//         });
//       })
//       ["catch"](() => {
//         next(false);
//       });
//     return false;
//   }
//   if (to.meta.title) {
//     document.title = to.meta.title;
//   }
//   next();
// });
/**
 * 动态设置html的font-size
 */
window.onload = () => getRem(750, 100);
window.onresize = () => getRem(750, 100);

function getRem(pwidth, prem) {
    let html = document.getElementsByTagName("html")[0];
    let oWidth =
        document.documentElement.clientWidth || document.body.clientWidth;
    html.style.fontSize = (oWidth / pwidth) * prem + "px";
}

//判断是否登录
// var iflogin = function () {
//      axios
//          .post(
//              "/wap/userHandle/getUserInfo",
//          )
//          .then(data => {
//              console.log(data.data.data);
//              var data = data.data.data;
//              console.log(localStorage.getItem('passWord'));
//              //没登陆 并且 上次是密码登录  并且  没有登出
//              //则免登陆
//              if(data === 'notLogin'&& localStorage.getItem('passWord')!= null && localStorage.getItem('logined')){
//                  axios
//                      .post(
//                          "/wap/user/login",
//                          qs.stringify({
//                              username: localStorage.getItem('userName'),
//                              passwordOrSms: localStorage.getItem('passWord'),
//                              type: 1
//                          })
//                      )
//                      .then(data => {
//                          console.log(data);
//                      })
//                      ["catch"](error => {
//                      console.log(error);
//                  });
//              }else{
//                  //上次是验证码登录  则需重新登录
//                  localStorage.removeItem('logined');
//              }
//          })
//          ["catch"](error => {
//              console.log(error);
//          });
//  }
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
})
